export function caseQuantity(quantity: number | null | undefined, unit: string, boxesPerCase?: number | null) {
  if (quantity == null || !Number.isFinite(quantity) || quantity < 0) return null;
  const normalized=unit.trim().toLocaleUpperCase("tr-TR");
  if (["KOLİ","KOLI","KOLI ADET"].includes(normalized)) return quantity;
  if (!["KUTU","SİLİNDİR","SILINDIR"].includes(normalized) || boxesPerCase == null || !Number.isSafeInteger(boxesPerCase) || boxesPerCase<=0) return null;
  return quantity/boxesPerCase;
}
